export default __webpack_public_path__ + "static/media/undraw_app_installation_re_h36x.15653754.svg";